import { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import PageHeader from "../component/layout/pageheader";
import CartTotals from "../component/section/CartTotal";

import ShopContextProvider, { ShopContext } from "../context/ShopContext";

const ShopCart = () => {
  const {
    products,
    cartItems,
    updateQuantity,
    navigate,
    currency
  } = useContext(ShopContext);

  const [cartData, setCartData] = useState([]);

  /* ================= BUILD CART DATA ================= */
  useEffect(() => {

    if (products.length > 0) {

      const temp = [];

      for (const productId in cartItems) {
        const product = products.find(p => p._id === productId);
        if (!product) continue;

        for (const size in cartItems[productId]) {
          const quantity = cartItems[productId][size];
          if (quantity > 0) {
            temp.push({
              ...product,
              size,
              quantity,
            });
          }
        }
      }

      setCartData(temp);
    }
  }, [cartItems, products]);

  /* ================= EMPTY CART GUARD ================= */
  if (cartData.length === 0) {
    return (
      <Fragment>
        <Header />
        <PageHeader title="SHOP CART" curPage="SHOP CART" />
        <div className="container text-center py-5">
          <h4>Your cart is empty</h4>
          <button
            className="default-button mt-3"
            onClick={() => navigate("/shop")}
          >
            <span>Go to Shop</span>
          </button>
        </div>
        <Footer />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Header />
      <PageHeader title="SHOP CART" curPage="SHOP CART" />

      <div className="shop-cart padding-top padding-bottom">
        <div className="container">
          <div className="section-wrapper">

            {/* ================= TABLE ================= */}
            <div className="cart-top">
              <table>
                <thead>
                  <tr>
                    <th className="cat-product">Product</th>
                    <th className="cat-price">Price</th>
                    <th className="cat-quantity">Quantity</th>
                    <th className="cat-toprice">Total</th>
                    <th className="cat-edit">Remove</th>
                  </tr>
                </thead>

                <tbody>
                  {cartData.map((item, index) => (
                    <tr key={index}>
                      <td className="product-item cat-product">
                        <div className="p-thumb">
                          <img src={item.image[0]} alt={item.name} />
                        </div>
                        <div className="p-content">
                          <Link to={`/shop-single/${item._id}`}>
                            {item.name}
                          </Link>
                          {item.size !== "default" && (
                            <p>Size: {item.size}</p>
                          )}
                        </div>
                      </td>

                      <td className="cat-price">
                        {currency}{item.price}
                      </td>

                      <td className="cat-quantity">
                        <div className="cart-plus-minus">
                          <button
                            className="dec qtybutton"
                            onClick={() =>
                              updateQuantity(item._id, item.size, item.quantity - 1)
                            }
                          >
                            -
                          </button>

                          <input
                            className="cart-plus-minus-box"
                            value={item.quantity}
                            readOnly
                          />

                          <button
                            className="inc qtybutton"
                            onClick={() =>
                              updateQuantity(item._id, item.size, item.quantity + 1)
                            }
                          >
                            +
                          </button>
                        </div>
                      </td>

                      <td className="cat-toprice">
                        {currency}{item.price * item.quantity}
                      </td>

                      <td className="cat-edit">
                        <button
                          onClick={() =>
                            updateQuantity(item._id, item.size, 0)
                          }
                        >
                          ✕
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ================= TOTAL ================= */}
            <div className="cart-bottom mt-4">
              <CartTotals />
            </div>
            <div className="cart-center mt-4">
              <button
                className="default-button mt-3 w-100"
                onClick={() => navigate("/place-order")}
              >
                <span>Proceed to Checkout</span>
              </button>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default ShopCart;
